import React from 'react'
import './footer.css'
import Socialicons from './Socialicons.js';




function Footer() {
    
    return (
        <div>
        
        <div className="" id="topContainer7">
       
        <div className="container">
       <div id='socialsicon'> <Socialicons /> </div> 
        <div className="" id="getintouch">

        
        
        </div>
       
        <p className=" content7">
        “You must be the change you wish to see in the world.”<br/> — Gandhi
        </p>
       <p className="email"><i class="fas fa-envelope-open-text"></i> Get In Touch... <br/>
    
        <a href="mailto:akilopelumi@gmail.com"  className="whatsapp_float">akilopelumi@gmail.com</a></p>

        <p className="phonenumber"><i class="fas fa-mobile"></i> Call/Whatsapp... <br/>
         <a href="https://wa.me/2348185967601" className="whatsapp_float"  target="_blank"
         rel="noopener noreferrer"> 08185967601 </a> </p> 
    
          <i class="far fa-copyright">Akilo Pelumi 2021</i>  
          
        </div>
        </div>
       
        </div>
    )
}

export default Footer
